<template>
  <div>
    <!-- from标单 -->
    <el-form
      ref="searchForm"
      :rules="rules"
      :inline="true"
      class="searchBoxLine"
      :model="searchForm"
    >
      <el-form-item label="项目名称:" prop="projectName">
        <el-input
          v-model.trim="searchForm.projectName"
          v-restrict-input
          placeholder="请输入项目名称"
        />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input
          v-model.trim="searchForm.contractNum"
          placeholder="请输入合同编号"
        />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="distributorName">
        <el-input
          v-model.trim="searchForm.agentName"
          v-restrict-input
          placeholder="请输入代理商名称"
        />
      </el-form-item>
      <el-form-item label="外销:" prop="salesManName">
        <el-input
          v-model.trim="searchForm.salesManName"
          v-restrict-input
          placeholder="请输入外销人员姓名"
        />
      </el-form-item>
      <el-form-item
        label="整改日期:"
        prop="beginDeliveryDateAfterRectification"
      >
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.beginDeliveryDateAfterRectification"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始日期"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endDeliveryDateAfterRectification"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="销往国家:" prop="overSeasSalesCountry">
        <el-input
          v-model.trim="searchForm.overSeasSalesCountry"
          placeholder="请输入销往国家"
        />
      </el-form-item>
      <el-form-item label="供货单位:" prop="supplier">
        <el-select
          v-model="searchForm.supplyUnitName"
          placeholder="请选择供货单位"
          clearable
        >
          <el-option
            v-for="item in supplierArr"
            :key="item.id"
            :label="item.supplyUnit"
            :value="item.supplyUnit"
          />
        </el-select>
      </el-form-item>
      <!-- 新添加的物品名称 -->
      <el-form-item label="物品名称:" prop="productName">
        <el-input
          v-model.trim="searchForm.productName"
          placeholder="请输入物品名称"
        />
      </el-form-item>
      <!-- 新添加的约定交付日期 -->
      <el-form-item label="约定交付日期:" prop="agreedDateStart">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.agreedDateStart"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始日期"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.agreedDateEnd"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 点击 勾选的产品加入到申请发货清单 按钮  -->
    <div class="addBtnBox">
      <el-button type="primary" @click="addDelivergoodsBtn">
        勾选的产品加入到申请发货清单
      </el-button>
      <!-- <div class="import-file-list-style">
        <el-upload
          action=""
          multiple
          :show-file-list="false"
          :http-request="importShippingList"
        >
          <el-button type="default" :loading="importButtonLoading">
            模板导入发货清单
          </el-button>
        </el-upload>
      </div>
      <el-button type="text" size="medium" @click="downloadTemplate">
        导入模板下载
      </el-button> -->
    </div>
    <!-- 未申请发货表格 -->
    <div v-loading="tableLoading" class="tableBody">
      <el-table
        ref="noAppilyTable"
        :data="PendingrequestableData"
        border
        highlight-current-row
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="left" />
        <el-table-column label="操作" align="left" width="50">
          <template v-slot="{ row }">
            <el-button type="text" @click="addTocheckedBtn(row)">
              选择
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="left"
          min-width="150"
        />
        <el-table-column
          prop="contractNum"
          label="合同编号"
          align="left"
          min-width="130"
        />
        <el-table-column
          prop="agentName"
          label="代理商名称"
          align="left"
          min-width="200"
        />
        <el-table-column
          prop="salesManName"
          label="外销"
          align="left"
          min-width="110"
        />
        <!-- <el-table-column
          prop="orderlinId"
          label="Order Line Id"
          align="left"
          min-width="120"
        /> -->
        <el-table-column
          prop="materialNumber"
          label="物品代码"
          align="left"
          width="135"
        />
        <el-table-column
          prop="productName"
          label="物品名称"
          align="left"
          min-width="180"
        />
        <el-table-column
          label="未发货数量"
          align="left"
          prop="unshipQuantity"
          width="90"
        >
          <template v-slot="{ row }">
            {{ row.unshipQuantity && Number(row.unshipQuantity).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="预估体积(m³)"
          align="left"
          width="100"
        >
          <template v-slot="{ row }">
            {{ getVolume(row) }}
          </template>
        </el-table-column>
        <!-- 预估重量 -->
        <el-table-column width="150" label="预估重量(kg)" align="left">
          <template v-slot="{ row }">
            <span v-if="row.index !== '小计'">
              {{ getWeight(row) || "——" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="实际结算单价"
          align="right"
          header-align="left"
          prop="productPriceSigle"
          width="100"
        >
          <template v-slot="{ row }">
            {{
              row.productPriceSigle && Number(row.productPriceSigle).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="amountSum"
          label="实际结算金额"
          align="right"
          header-align="left"
          width="100"
        >
          <template v-slot="{ row }">
            {{ row.amountSum && Number(row.amountSum).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="salesType"
          label="现销/赊销"
          align="left"
          width="80"
        />
        <el-table-column
          prop="physicalFlag"
          label="是否实物"
          align="left"
          width="80"
        >
          <template v-slot="{ row }">
            {{ row.physicalFlag ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ row.batteryFlag ? "是" : "否" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="expectedDeliveryDate"
          label="客户期望发货日"
          align="left"
          min-width="180"
        />
        <el-table-column
          prop="agreedDate"
          label="约定交付日期"
          align="left"
          min-width="180"
        />
        <el-table-column
          prop="deliveryDateAfterRectification"
          label="整改后交期"
          align="left"
          min-width="180"
        />
        <el-table-column
          prop="warehouse"
          label="仓位"
          align="left"
          min-width="120"
        />
        <el-table-column
          prop="overSeasSalesCountry"
          label="销往国家"
          align="left"
          min-width="120"
        />
        <el-table-column
          prop="department"
          label="部门"
          align="left"
          min-width="180"
        />
      </el-table>
      <div style="text-align: left; margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="->,total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <div>
      <h3>已选择的待申请发货清单</h3>
    </div>
    <div class="selectedBtnsBox">
      <el-button type="primary" @click="removeTheSelectedProduct">
        移除勾选的产品
      </el-button>
      <el-button type="default" @click="DelivergoodsIsShow">
        申请发货
      </el-button>
    </div>
    <!-- 已选择申请发货清单 -->
    <div v-loading="tableLoading" class="tableBody">
      <el-table
        ref="selectedTable"
        :data="HaveAppliedTableData"
        border
        style="width: 100%"
        @selection-change="RemoveSelectionChange"
      >
        <el-table-column type="selection" width="55" align="left" />
        <el-table-column label="操作" align="left" min-width="50">
          <template v-slot="{ row }">
            <el-button
              type="text"
              style="color: red"
              @click="removecheckedBtn(row)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="left"
          min-width="150"
        />
        <el-table-column
          prop="contractNum"
          label="合同编号"
          align="left"
          min-width="150"
        />
        <!-- <el-table-column
          prop="orderlinId"
          label="Order Line Id"
          align="left"
          min-width="120"
        /> -->
        <el-table-column
          prop="agentName"
          label="代理商名称"
          align="left"
          min-width="120"
        />
        <el-table-column
          prop="materialNumber"
          label="物品代码"
          align="left"
          width="100"
        />
        <el-table-column
          prop="productName"
          label="物品名称"
          align="left"
          min-width="150"
        />
        <el-table-column
          label="未发货数量"
          align="left"
          prop="unshipQuantity"
          width="90"
        >
          <template v-slot="{ row }">
            {{ row.unshipQuantity && Number(row.unshipQuantity).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="预估体积(m³)"
          align="left"
          width="100"
        >
          <template v-slot="{ row }">
            {{ getVolume(row) }}
          </template>
        </el-table-column>
        <!-- 预估重量 -->
        <el-table-column width="150" label="预估重量(kg)" align="left">
          <template v-slot="{ row }">
            <span v-if="row.index !== '小计'">
              {{ getWeight(row) || "——" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="warehouse"
          label="仓位"
          align="left"
          min-width="120"
        />
        <el-table-column
          label="实际结算单价"
          align="right"
          header-align="left"
          prop="productPriceSigle"
          width="100"
        >
          <template v-slot="{ row }">
            {{
              row.productPriceSigle && Number(row.productPriceSigle).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="amountSum"
          label="实际结算金额"
          align="right"
          header-align="left"
          width="100"
        >
          <template v-slot="{ row }">
            {{ row.amountSum && Number(row.amountSum).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="salesType"
          label="现销/赊销"
          align="left"
          width="90"
        />
        <el-table-column
          prop="physicalFlag"
          label="是否实物"
          align="left"
          width="80"
        >
          <template v-slot="{ row }">
            {{ row.physicalFlag ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="80"
        >
          <template v-slot="{ row }">
            {{ row.batteryFlag ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="expectedDeliveryDate"
          label="客户期望发货日"
          align="left"
          min-width="180"
        />
        <el-table-column
          prop="agreedDate"
          label="约定交付日期"
          align="left"
          min-width="180"
        />
        <el-table-column
          prop="deliveryDateAfterRectification"
          label="整改后交期"
          align="left"
          min-width="180"
        />
        <el-table-column
          prop="warehouse"
          label="仓位"
          align="left"
          min-width="120"
        />
        <el-table-column
          prop="overSeasSalesCountry"
          label="销往国家"
          align="left"
          min-width="110"
        />
        <el-table-column
          prop="department"
          label="部门"
          align="left"
          min-width="150"
        />
      </el-table>
      <!-- 已勾选的 分页 -->
      <!-- <div style="text-align: right; margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div> -->
    </div>
    <!-- 申请发货 -->
    <el-dialog
      title="申请发货"
      :visible.sync="isShowDelivergoodsdialog"
      :show-close="true"
      width="90%"
      :close-on-click-modal="false"
    >
      <ApplyForDelivery-Dialog :product="HaveAppliedTableData" />
    </el-dialog>
    <!-- 校验弹框 -->
    <el-dialog
      :visible.sync="isShowCheckdialog"
      :show-close="true"
      title="提示"
      width="500px"
    >
      <div>
        <!-- 校验失败 -->
        <div v-if="isShowErrorCheck">
          <div style="margin-bottom: 20px">
            <p style="display: flex; justify-content: space-around">
              <i
                class="el-icon-warning"
                style="color: #e6a23c; font-size: 20px"
              />
              <span>
                {{ this.errorPrompt + "失败" }}
              </span>
            </p>
          </div>
        </div>

        <!-- 校验成功 -->
        <div v-if="isShowSuccessCheck">
          <div style="margin-bottom: 20px">
            <p style="display: flex; justify-content: space-around">
              <i
                class="el-icon-success"
                style="color: #66ff66; font-size: 20px"
              />
              <span>
                {{ this.successPrompt + "成功" }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <el-button
        type="primary"
        style="margin-bottom: 50px; float: right"
        @click="close = isShowCheckdialog = false"
      >
        确定
      </el-button>
    </el-dialog>
  </div>
</template>
<script type="es6">
import ApplyForDeliveryDialog from './ApplyForDeliveryDialog.vue';
import { getSupplyUnitList } from '../../../API/index'; // 供货单位
import { bgIntelPendingRequisitionList, checkinterface, getImportShippingDataList } from '@/API/international.js'; // 列表数据接口
import EventBus from '@/libs/eventBus.js';
import { downloadUrlFile } from '@/libs/util';
import big from 'big.js';
export default {
  components: {
    ApplyForDeliveryDialog
  },
  data () {
    var isBig = (rule, value, callback) => {
      if (value <= this.searchForm.beginDeliveryDateAfterRectification) {
        callback(new Error('增改后交期不能小于等于起始条件!'));
      } else {
        callback();
      }
    };
    return {
      isShowCheckdialog: false, // 校验提示弹框
      isShowSuccessCheck: false, // 校验成功显示
      isShowErrorCheck: false, // 校验失败显示
      isShowDelivergoodsdialog: false,
      errorPrompt: '', // 校验失败提示
      successPrompt: '', // 校验成功提示
      Loading: false,
      // 搜索表单 搜索字段待确定
      searchForm: {
        projectName: '', // 项目名称
        contractNum: '', // 合同编号
        agentName: '', // 代理商名称 agentName
        salesManName: '', // 外销 salesManName
        beginDeliveryDateAfterRectification: '', // 开始日期 beginDeliveryDateAfterRectification
        endDeliveryDateAfterRectification: '', // 结束日期 endDeliveryDateAfterRectification
        overSeasSalesCountry: '', // 销往国家 overSeasSalesCountry
        supplyUnitName: '', // 供货单位  supplyUnitName
        productName: '', // 物品名称
        agreedDateStart: '', // 约定交付开始日期
        agreedDateEnd: '' // 约定交付截止日期
      },
      supplierArr: [], // 供货单位下拉框
      // 整改日期 验证规则
      rules: {
        endDeliveryDateAfterRectification: [
          { validator: isBig, trigger: 'blur' }
        ]
      },
      // 选择 结束 日期
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.beginDeliveryDateAfterRectification) {
            let date = new Date(this.searchForm.beginDeliveryDateAfterRectification);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      // 未申请发货表格数据
      PendingrequestableData: [],
      // 已申请发货表格数据
      HaveAppliedTableData: [],
      //  未申请发货表格选择数据
      PendingmultipleSelection: [],
      // 移除 申请发货的数据
      RemoveSelectedProduct: [],
      tableLoading: false,
      importButtonLoading: false,
      page: {
        pageSize: 50,
        total: 0,
        currentPage: 1
      },
      importDataList: [],
      isImportStatus: false,
      sellectMore: true
    };
  },
  methods: {
    // 重置表单
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.agentName = '';
      this.searchForm.supplyUnitName = '';
      this.searchForm.beginDeliveryDateAfterRectification = '';
      this.searchForm.endDeliveryDateAfterRectification = '';
      this.searchForm.productName = ''; // 物品名称
      this.searchForm.agreedDateStart = ''; // 约定交付起时间
      this.searchForm.agreedDateEnd = ''; // 约定交付止时间
      this.page.currentPage = 1;
      this.isImportStatus = false;
      this.getDataList();
    },
    // 导入发货清单
    importShippingList (upload) {
      this.importButtonLoading = true;
      let formDate = new FormData();
      formDate.append('file', upload.file);
      getImportShippingDataList(formDate).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.isImportStatus = true;
          this.importDataList = data;
          // this.doSearch();
          this.getDataList((res) => {
            if (res.length) {
              this.$refs.noAppilyTable.toggleAllSelection(res);
              this.PendingmultipleSelection = res;
              this.HaveAppliedTableData = [];
              this.addDelivergoodsBtn();
            }
          });
          this.$message.success('导入完成,请前往列表查看结果!');
        }
      }).catch(() => {
        this.$message.error('导入过程中出现错误，请稍后再试!');
      }).finally(() => {
        this.importButtonLoading = false;
      });
    },
    // 导入发货清单
    addImportShippingList () {
      this.importShippingList();
    },
    // 导入模板下载
    downloadTemplate () {
      downloadUrlFile('/发货清单模板.xlsx');
    },
    //  获取列表
    getDataList (fn) {
      this.tableLoading = true;
      let params = {
        projectName: this.searchForm.projectName || undefined, // 项目名称
        contractNum: this.searchForm.contractNum || undefined, // 合同编号
        agentName: this.searchForm.agentName || undefined, // 代理商名称 agentName
        salesManName: this.searchForm.salesManName || undefined, // 外销 salesManName
        beginDeliveryDateAfterRectification: this.searchForm.beginDeliveryDateAfterRectification || undefined, // 开始日期 beginDeliveryDateAfterRectification
        endDeliveryDateAfterRectification: this.searchForm.endDeliveryDateAfterRectification || undefined, // 结束日期 endDeliveryDateAfterRectification
        overSeasSalesCountry: this.searchForm.overSeasSalesCountry || undefined, // 销往国家 overSeasSalesCountry
        supplyUnitName: this.searchForm.supplyUnitName || undefined, // 供货单位  supplyUnitName
        productName: this.searchForm.productName || undefined, // 物品名称
        agreedDateStart: this.searchForm.agreedDateStart || undefined, // 约定交付开始日期
        agreedDateEnd: this.searchForm.agreedDateEnd || undefined, // 约定交付截止日期
        pageNum: this.page.currentPage, // 第几页
        pageSize: this.page.pageSize, // 每页几条
        importPartialShipmentList: this.isImportStatus ? this.importDataList : undefined
      };
      bgIntelPendingRequisitionList(params).then(res => {
        if (res.data.status === '200') {
          this.tableLoading = false;
          if (res.data.data.list) {
            let productList = [];
            let zeroList = [];
            res.data.data.list.forEach(item => {
              if (item.physicalFlag) {
                productList.push(item);
                let l1Arr = [];
                let l2Arr = [];
                res.data.data.list.forEach(one => {
                  if (item.serviceDescription && item.serviceDescription.includes(one.productName) && one.amountSum) {
                    if (one.serviceLevel === 1) {
                      l1Arr.push(one);
                    } else if (one.serviceLevel === 2) {
                      l2Arr.push(one);
                    } else {
                      productList.push(one);
                    }
                  }
                });
                productList = [...productList, ...l1Arr, ...l2Arr];
              } else if (!item.amountSum && !item.physicalFlag) {
                zeroList.push(item);
              } else {
                if (!productList.find(obj => obj.lineNum === item.lineNum && obj.orderlinId === item.orderlinId)) {
                  productList.push(item);
                }
              }
            });
            this.PendingrequestableData = [...productList, ...zeroList];
          } else {
            this.PendingrequestableData = res.data.data.list;
          }

          // this.PendingrequestableData = res.data.data.list;
          this.page.total = res.data.data.total;
          // 如果 已选择列表有数据
          if (this.HaveAppliedTableData.length) {
            // 从新赋值 带勾选列表数据
            this.PendingrequestableData = this.PendingrequestableData.filter(
              item => !this.HaveAppliedTableData.some(it => it.orderlinId === item.orderlinId)
            );
          }
          if (fn) fn(res.data.data.list);
        }
      }).catch(err => {
        this.tableLoading = false;
        this.$message.error(err.message);
      });
    },
    // 搜索
    doSearch () {
      this.tableLoading = true;
      if (this.page.currentPage !== 1) {
        this.page.currentPage = 1;
      }
      let params = {
        projectName: this.searchForm.projectName || undefined, // 项目名称
        contractNum: this.searchForm.contractNum || undefined, // 合同编号
        agentName: this.searchForm.agentName || undefined, // 代理商名称 agentName
        salesManName: this.searchForm.salesManName || undefined, // 外销 salesManName
        beginDeliveryDateAfterRectification: this.searchForm.beginDeliveryDateAfterRectification || undefined, // 开始日期 beginDeliveryDateAfterRectification
        endDeliveryDateAfterRectification: this.searchForm.endDeliveryDateAfterRectification || undefined, // 结束日期 endDeliveryDateAfterRectification
        overSeasSalesCountry: this.searchForm.overSeasSalesCountry || undefined, // 销往国家 overSeasSalesCountry
        supplyUnitName: this.searchForm.supplyUnitName || undefined, // 供货单位  supplyUnitName
        productName: this.searchForm.productName || undefined, // 物品名称
        agreedDateStart: this.searchForm.agreedDateStart || undefined, // 约定交付开始日期
        agreedDateEnd: this.searchForm.agreedDateEnd || undefined, // 约定交付截止日期
        pageNum: this.page.currentPage, // 第几页
        pageSize: this.page.pageSize, // 每页几条
        importPartialShipmentList: this.isImportStatus ? undefined : this.importDataList // 导入清单的参数集合
      };
      bgIntelPendingRequisitionList(params).then(res => {
        if (res.data.status === '200') {
          this.tableLoading = false;
          // this.PendingrequestableData = res.data.data.list;

          if (res.data.data.list) {
            let productList = [];
            let zeroList = [];
            res.data.data.list.forEach(item => {
              if (item.physicalFlag) {
                productList.push(item);
                let l1Arr = [];
                let l2Arr = [];
                res.data.data.list.forEach(one => {
                  if (item.serviceDescription && item.serviceDescription.includes(one.productName) && one.amountSum) {
                    if (one.serviceLevel === 1) {
                      l1Arr.push(one);
                    } else if (one.serviceLevel === 2) {
                      l2Arr.push(one);
                    } else {
                      productList.push(one);
                    }
                  }
                });
                productList = [...productList, ...l1Arr, ...l2Arr];
              } else if (!item.amountSum && !item.physicalFlag) {
                zeroList.push(item);
              } else {
                if (!productList.find(obj => obj.lineNum === item.lineNum && obj.orderlinId === item.orderlinId)) {
                  productList.push(item);
                }
              }
            });
            const merged = Array.from(
              zeroList.reduce((map, item) => {
                const { productName } = item;
                const existing = map.get(productName);
                if (existing) {
                  existing.productNum += item.productNum;
                } else {
                  map.set(productName, { ...item });
                }
                return map;
              }, new Map())
            ).map(([_, value]) => value);

            this.PendingrequestableData = [...productList, ...merged];
          } else {
            this.PendingrequestableData = res.data.data.list;
          }
          // 模板导入清单,提示失败的数据
          if (res.data.data.importTip) {
            this.$alert(res.data.data.importTip, '提示', {
              confirmButtonText: '确定',
              customClass: 'import-file-alert-tips-style'
            });
            this.importButtonLoading = false;
          }
          if (this.HaveAppliedTableData.length) {
            // 从新赋值 带勾选列表数据
            this.PendingrequestableData = this.PendingrequestableData.filter(
              item => !this.HaveAppliedTableData.some(it => it.orderlinId === item.orderlinId)
            );
          }
          this.page.total = res.data.data.total;
        }
      }).catch(err => {
        this.tableLoading = false;
        this.$message.error(err.message);
      });
    },
    // 点击勾选申请发货按钮
    addDelivergoodsBtn () {
      // 未申请发货表格选择数据 已有数据
      if (this.PendingmultipleSelection.length) {
        let allArr = [...this.HaveAppliedTableData, ...this.PendingmultipleSelection];
        // 发送校验数据
        let checkArr = [];
        allArr.forEach((item, index) => {
          checkArr.push({
            salesType: item.salesType === '现销' ? 1 : 2, // 现销/赊销
            contractNum: item.contractNum, // 合同编号
            overSeasSalesCountry: item.overSeasSalesCountry, // 销往国家
            deptName: item.department, // 部门  department
            deliveryDateAfterRectification: item.deliveryDateAfterRectification, // 整改后交期
            // deliveryDateAfterRectification: '2023-4-5 00:00:00', // 整改后交期 2022-12-19 00:00:00
            productName: item.productName, // 产品规格型号
            erplinId: item.orderlinId,
            physicalFlag: item.physicalFlag,
            expectedDeliveryDate: item.expectedDeliveryDate,
            unshipQuantity: Number(item.unshipQuantity), // 未发货数量
            materialNumber: item.materialNumber, // 物品代码
            productPriceSigle: item.productPriceSigle,
            warehouse: item.warehouse,
            // propertyNum: 0, // 属性号 待确认
            agreedDate: item.agreedDate,
            softFlag: 'N',
            supplyUnitId: item.supplyUnitName, // 销往国家id
            currencyId: item.currencyId || 'USD', // 币种编码
            currencyName: item.currencyName || 'USD', // 币种名称
            accountPeriod: item.accountPeriod, // 账期
            erpProductListPrice: item.unitListPrice // list价
          });
        });
        // 校验请求
        checkinterface(checkArr).then(res => {
          if (res.status === 200) {
            // 校验产品信息不通过
            if (res.data && res.data.status === '71000189') {
              this.isShowCheckdialog = true;
              this.errorPrompt = res.data.err;
              this.isShowErrorCheck = true;
              this.isShowSuccessCheck = false;
              return;
            };
            // 校验 时间不通过
            if (res.data && res.data.status === '71000200') {
              this.isShowCheckdialog = true;
              this.errorPrompt = res.data.err;
              this.isShowErrorCheck = true;
              this.isShowSuccessCheck = false;
              return;
            }
            // 校验 产品通过 && res.data.status !== '9999'
            if (res.data.data) {
              this.successPrompt = res.data.data;
              this.isShowSuccessCheck = true;
              this.isShowCheckdialog = true;
              this.isShowErrorCheck = false;
              // 添加到 已申请发货清单
              this.addToSelected();
              return;
            }
            // 产品整改后交期 在当前时间之前 直接 提示操作成功
            if (res.data.err === '操作成功') {
              this.$message.success(res.data.err);
              this.addToSelected();
            }
          }
        });
      } else {
        this.$message.warning('当前未有勾选的产品，请选择产品后在操作！');
      }
    },
    // 添加
    addToSelected () {
      // 添加到 已申请发货清单
      this.HaveAppliedTableData.push(...this.PendingmultipleSelection);
      // 过滤数据
      this.PendingrequestableData = this.PendingrequestableData.filter(
        item => !this.PendingmultipleSelection.some(it => it.orderlinId === item.orderlinId)
      );
    },
    // 点击选择
    addTocheckedBtn (val) {
      let that = this;
      this.PendingrequestableData.forEach(item => {
        if (val.serviceDescription && val.serviceDescription.includes(item.productName) && Number(val.productPriceSigle) > 0) {
          that.$refs.noAppilyTable.toggleRowSelection(item, true);
        }
      });
      console.log(this.PendingmultipleSelection);
      this.$refs.noAppilyTable.toggleRowSelection(val, true);
    },
    // 点击移除
    removecheckedBtn (val) {
      this.$refs.selectedTable.toggleRowSelection(val, true);
    },
    // 未申请发货表格多选
    handleSelectionChange (val) {
      this.PendingmultipleSelection = val;
      if (this.sellectMore) {
        this.sellectMore = false;
        let that = this;
        this.PendingrequestableData.forEach(item => {
          if (val[val.length - 1]?.serviceDescription && val[val.length - 1]?.serviceDescription.includes(item.productName) && Number(val.productPriceSigle) > 0) {
            // that.PendingmultipleSelection.push(item);
            that.$refs.noAppilyTable.toggleRowSelection(item, true);
          }
        });
        this.sellectMore = true;
      }
    },
    // 移除
    RemoveSelectionChange (val) {
      this.RemoveSelectedProduct = val;
    },
    // 点击 移除勾选产品
    removeTheSelectedProduct () {
      if (this.RemoveSelectedProduct.length) {
        // 添加
        this.PendingrequestableData.push(...this.RemoveSelectedProduct);
        this.HaveAppliedTableData = this.HaveAppliedTableData.filter(
          item => !this.RemoveSelectedProduct.some(it => it.orderlinId === item.orderlinId)
        );
        this.$message.success('操作成功！');
      }
    },
    // 未申请发货分页
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.getDataList();
    },
    // 第几页
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.getDataList();
    },
    // 申请发货
    DelivergoodsIsShow () {
      if (!this.HaveAppliedTableData.length) {
        this.$message.warning('请添加产品后再操作!');
        return;
      }
      /**
      //  * 校验
      //  * 若所勾选的产品总体积超过60立方，则toast错误提示：“已选择的产品总体积超过60立方，当前总体积为xx立方，请重新选择”，不可提交；xx为所选产品材积之和；
      //  * 若所勾选的产品总项目超过50项，则toast错误提示：“已选择的产品超过50项，当前为xx项，请重新选择”，不可提交；xx为所选产品项目之和；
      //  */
      let volumes = big(0);
      const limitVolume = big(60);
      this.HaveAppliedTableData.forEach((item) => {
        let length = big(this.getNumber(item.length)).div(big(1000));
        let height = big(this.getNumber(item.high)).div(big(1000));
        let width = big(this.getNumber(item.width)).div(big(1000));
        let quantity = big(this.getNumber(item.unshipQuantity));
        let boxcount = big(this.getNumber(item.boxCnt));
        volumes.plus(length.times(height).times(width).times(quantity).times(boxcount));
      });
      if ((volumes.minus(limitVolume)).toNumber() > 0) {
        this.$message.error(`已选择的产品总体积超过60立方，当前总体积为${volumes.toFixed(4)}立方，请重新选择!`);
        return;
      }

      const deModulationRepetition = [];
      this.HaveAppliedTableData.forEach((item) => {
        if (!deModulationRepetition.includes(item.productName)) {
          deModulationRepetition.push(item.productName);
        }
      });
      if (deModulationRepetition.length > 50) {
        this.$message.error(`已选择的产品超过50项，当前为${deModulationRepetition.length}项，请重新选择!`);
        return;
      }

      this.isShowDelivergoodsdialog = true;
    },
    getNumber (value) {
      return Number(value || 0) || 0;
    },
    // 获取供货单位
    getSupplyUnitList () {
      getSupplyUnitList().then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.supplierArr = res.data.data;
        }
      });
    },
    getVolume (row) {
      // 如果为空: 设置默认值
      if (!row.length || !row.high || !row.width) {
        return '——';
      }
      let length = big(this.getNumber(row.length)).div(big(1000));
      let height = big(this.getNumber(row.high)).div(big(1000));
      let width = big(this.getNumber(row.width)).div(big(1000));
      let quantity = big(this.getNumber(row.unshipQuantity));
      let boxcount = big(this.getNumber(row.boxCnt));
      //  结果乘发货数量  unshipQuantity  再除以装箱数 boxCnt
      return (length.times(height).times(width).times(quantity).div(boxcount)).toFixed(4);
    },
    // 预估重量
    getWeight (row) {
      // 毛重计算公式="未发货数量"/"装箱数"*运输箱重量
      // 未发货数量: unshipQuantity
      // 装箱数: boxCnt
      // 运输箱重量: unitWeight
      if (!row.unshipQuantity || !row.boxCnt || !row.unitWeight || this.getNumber(row.boxCnt) === 0 ||
        this.getNumber(row.unitWeight) === 0) {
        return null;
      }
      const unshippedQuantity = big(this.getNumber(row.unshipQuantity)); // 未发货数量
      const packingQuantity = big(this.getNumber(row.boxCnt)); // 装箱数
      const transportBoxWeight = big(this.getNumber(row.unitWeight)); // 运输箱重量
      return big(unshippedQuantity).div(packingQuantity).times(transportBoxWeight).toFixed(2);
    }
  },
  mounted () {
    // 获取别表数据
    this.getDataList();
    // EventBus 传值
    // 关闭申请发货弹出框
    EventBus.$on('closeDelivergoodsdialog', val => {
      this.isShowDelivergoodsdialog = val;
    });
    EventBus.$on('clearHaveAppliedTableData', val => {
      if (val) {
        if (val.data.status === '200') {
          this.HaveAppliedTableData = [];
        }
      }
    });
    // 获取供货单位
    this.getSupplyUnitList();
  },
  destroyed () {
    EventBus.$off('closeDelivergoodsdialog');
    EventBus.$off('clearHaveAppliedTableData');
  }
};
</script>

<style scoped>
.addBtnBox {
  margin: 15px 5px;
  display: flex;
  align-items: center;
}
.import-file-list-style {
  margin-left: 20px;
  margin-right: 20px;
}
.selectedBtnsBox {
  margin: 10px 0;
}
.rj-flex :deep(.el-input) {
  width: 165px;
}
.rj-flex :deep(.el-input__inner) {
  padding-right: 0;
}
:deep(.el-input__suffix) {
  right: 0;
}
.searchBoxLine .el-input {
  max-width: 165px;
}
</style>
<style>
.import-file-alert-tips-style {
  word-break: keep-all;
  max-height: 400px;
  overflow-y: auto;
}
</style>
